import { invoke, on } from "@hybird/core/bridge/hybirdBridge";
import { BridgeMethod } from "@hybird/core/bridge/core";

export class FlutterEpsonScanner extends BridgeMethod {
  constructor() {
    super();
  }


  /**
   * 查找USB扫描器
   * @returns {Promise<{success: boolean}>}
   */
  async findEpsonUsbScanner() {
    return await invoke("findEpsonUsbScanner");
  }

  /**
   * 连接USB扫描器
   * @returns {Promise<{success: boolean}>}
   */
  async connectEpsonScanner() {
    return await invoke("connectEpsonUsbScanner");
  }

  /**
   * 断开USB扫描器连接
   * @returns {Promise<{success: boolean}>}
   */
  async disconnectEpsonScanner() {
    return await invoke("disconnectEpsonUsbScanner");
  }

  // 开始扫描
  async startEpsonScan({ onAllDoneListen, onOneByOneListen, onError, onDone, duplex }) {
    return await invoke("startEpsonScanner", {
      params: {
        duplex,
      },
      on: {
        onAllDoneListen: (params) => onAllDoneListen(params),
        onOneByOneListen: (params) => onOneByOneListen(params),
        onError: (params) => onError(params),
        onDone: (params) => onDone(params),
      },
    });
  }

  // 关闭扫描
  async closeEpsonScan() {
    return await invoke("closeEpsonScanner");
  }
}
